// extracted by mini-css-extract-plugin
module.exports = {"block":"V945W","body":"DSCOK","content":"npERo","open":"KiqFR","overflowHidden":"Lp6as","button":"a9kBv"};